import { number, object } from 'zod';

import { IS_REQUIRED } from '@occc-app/lib/constants/validationMessages';

export const AwardExternalPointsSchema = object({
  maximum: number({ required_error: IS_REQUIRED }),
});
